"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountsPage = exports.AccountsPageConfig = void 0;
const core_api_1 = require("@ikegps/core-api");
const icons_1 = require("../components/icon/icons");
const i18n_1 = require("../i18n");
const accounts_1 = require("../modules/accounts/accounts");
const accounts_ctrl_1 = require("../modules/accounts/accounts.ctrl");
const services_1 = require("../services");
const page_1 = require("./page");
exports.AccountsPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.accountList,
    path: '/user/accounts',
    auth: {
        required: true,
        userLevel: [core_api_1.IkeUserRole.ROOT]
    },
    nav: {
        name: i18n_1.T.LIST_USER_ACCOUNTS,
        icon: icons_1.MaterialIcon.PERSON
    }
};
class AccountsPage extends page_1.IkePage {
    constructor() {
        super(exports.AccountsPageConfig);
        this.name = 'AcceptInvite';
        const ctrl = new accounts_ctrl_1.AccountsCtrl();
        this.component = new accounts_1.AccountsComponent(ctrl);
    }
    get nodes() {
        if (!services_1.Services.User.hasUser) {
            return null;
        }
        return this.component.view();
    }
}
exports.AccountsPage = AccountsPage;
//# sourceMappingURL=accounts.page.js.map